import { Box, Button, Stack, Typography } from "@/common/styles/style";
import { styles } from "./style";
import { useState } from "react";
import { lisenceList } from "./lisense";

export default function LisenceScreen() {
  const [expandedLicenseIndex, setExpandedLicenseIndex] = useState<
    number | null
  >(null);

  const toggleLicense = (index: number) => {
    setExpandedLicenseIndex((prev) => (prev === index ? null : index));
  };

  const handleHomepageClick = (url: string) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.title}>
        <Typography variant="h3">Credits</Typography>
      </Box>
      <Stack spacing={2}>
        {lisenceList.map((lisence, index) => (
          <Box sx={styles.lisencebox} key={index}>
            <Stack direction="row" sx={styles.viewbox}>
              <Typography variant="h6">{lisence.name}</Typography>
              <Stack direction="row" spacing={1}>
                <Button
                  variant="text"
                  size="small"
                  sx={styles.button}
                  onClick={() => toggleLicense(index)}
                >
                  <Typography variant="body2">
                    {expandedLicenseIndex === index
                      ? "Hide License"
                      : "Show License"}
                  </Typography>
                </Button>
                <Typography>-</Typography>
                <Button
                  variant="text"
                  size="small"
                  sx={styles.button}
                  onClick={() => handleHomepageClick(lisence.url)}
                >
                  <Typography variant="body2">homepage</Typography>
                </Button>
              </Stack>
            </Stack>
            {expandedLicenseIndex === index && (
              <Box>
                <pre style={styles.lisenceText}>{lisence.lisence}</pre>
              </Box>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
